export default __webpack_public_path__ + "a30ed63da25fd2f2a9537e8402602db1.png";